// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2Qnit","item":"PaymentsMobile_item__1uxSb","label":"PaymentsMobile_label__2JDjM","amount":"PaymentsMobile_amount__2LkqN"};